'use client'
import { usePathname } from "@/locales/routing";
import { fromPairs } from "lodash";
import { useSearchParams } from "next/navigation";
import { useRouter } from "@/locales/routing";
import { useCallback, useMemo, useTransition } from "react";

// query参数跳转
export const useQueryPush = (): [boolean, (url: string, opt: { key: string, val: string }) => void] => {
  const router = useRouter()
  const search = useSearchParams()
  const pathname = usePathname()

  
  const searchMap = useMemo(() => {
    return fromPairs([...search.entries()])
  }, [search])

  const [isPending, startTransition] = useTransition();

  const transitionPush = useCallback((url: string, { key, val }) => {
    startTransition(() => {
      const obj = Object.assign(searchMap, { [key]: val })
      if (val === null) delete obj[key]
      const params = Object.keys(obj).map(key => `${key}=${searchMap[key]}`).join('&')
      if (url === './') url = pathname
      router.replace(`${url}?${params}`)
    })
  }, [searchMap, startTransition, router])


  return [isPending, transitionPush]
}